import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PaginationInstance } from 'ngx-pagination';

@Component({
    selector: 'da-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PaginationComponent implements OnInit {
    @Input() showStaticForPrototype = false;
    @Output() pageChange: EventEmitter<number> = new EventEmitter<number>();
    @Input() currentPage: number;
    @Input() config: PaginationInstance = {
        id: 'custom',
        itemsPerPage: 5,
        currentPage: 1,
        totalItems: 0
    };

    constructor() {}

    ngOnInit() {}

    onPageChange($event: any) {
        this.config.currentPage = $event;
        this.pageChange.emit(this.config.currentPage);
    }
}
